<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_OneKeyBooking')"
    width="1020px"
    :close-on-click-modal="false"
    destroy-on-close
    class="app-main-inner one-key-booking-dialog"
  >
    <div class="app-main-inner-row">
      <span v-html="$t('CargoMsg.Cargo_OneKeyBookingTip1', [total])" />
    </div>
    <div class="app-main-inner-row row-grid-dialog" style="height: 350px;padding-bottom: 20px;">
      <cargo-ag-grid
        config-module="101901"
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
    <div class="pagination-wrapper">
      <cargo-pagination
        config-module="101901"
        :total="total"
        :page.sync="params.pageNum"
        :limit.sync="params.pageSize"
        @pagination="loadData()"
      />
    </div>
    <div class="app-main-inner-row">
      <span style="color: #acacac" v-html="$t('CargoMsg.Cargo_OneKeyBookingTip2')" />
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" no="1" @click="oneKeyBooking">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button size="mini" no="2" @click="innerVisible = false">{{ $t('SeaExport.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import OperationRender from '@/components/OperationRender'
import { getCanSendBookingJob, oneKeyBooking } from '@/api/seaExport/edi'
import $store from '@/store'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'OneKeyBooking',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        defaultColDef: {
          resizable: true,
          params: true
        },
        pagination: false
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture2'),
          field: 'etd',
          colId: 'etd',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          colId: '',
          width: 80,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_Remove'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.params.excludeJobUuids.push(params.uuid)
                  this.loadData()
                },
                visible: () => true
              }
            ]
          }
        }
      ],
      total: 0,
      params: {
        pageNum: 1,
        pageSize: 20,
        opOffice: $store.getters.currentOfficeId,
        excludeJobUuids: []
      },
      rowData: []
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async loadData(params) {
      if (params) {
        this.params.pageNum = params.pageNum
        this.params.excludeJobUuids = params.excludeJobUuids
      }
      await getCanSendBookingJob(this.params).then(res => {
        if (res.data.list && res.data.list.length > 0) {
          this.total = Number(res.data.total)
          this.rowData = res.data.list
        } else {
          this.total = 0
          this.rowData = []
        }
      })
    },
    oneKeyBooking() {
      if (this.total === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanNotBooking'))
        return
      }
      const loading = getLoading()
      oneKeyBooking({ opOffice: $store.getters.currentOfficeId, excludeJobUuids: this.params.excludeJobUuids }).then(res => {
        this.innerVisible = false
        this.$message.success(this.$t('CargoMsg.Cargo_OneKeyBookingTip3'))
        this.$emit('refresh')
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.one-key-booking-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
